import dayjs from "dayjs";

export const adaptAppBrand = (data: IAppBrand): Partial<AppBrand> => {
	return {
		id: data.id,
		name: data.name,
		brandColor: data.brand_color,
		textColor: data.text_color,
		createdAt: dayjs(data.created_at).format("DD MMM YYYY"),
		monthCreated: data.created_at_month,
		yearCreated: data.created_at_year,
		activeDays: data.active_days,
		createdBy: data.created_by
			? {
					id: data.created_by.id,
					firstName: data.created_by.first_name,
					lastName: data.created_by.last_name
			  }
			: undefined,
		published: data.published,
		updatedAt: dayjs(data.updated_at).format("DD MMM YYYY")
	};
};

export const adaptAppBrands = (data: IAppBrand[]): Partial<AppBrand>[] => {
	return data.map(adaptAppBrand);
};
